// extracted by mini-css-extract-plugin
export default {"addContainer":"styles-module__addContainer__src-labstep-web-components-GroupAutoSharing-Table-_uwMu_"};